
  const datas = [
    {
      name: "Bakery",
      img: "assets/img/logo2.png",
      id: "Bakery"
    },
    {
      name: "BBQ",
      img: "assets/img/logo2.png",
      id: "BBQ"
    },{
      name: "Steakhouse",
      img: "assets/img/logo2.png",
      id: "Steakhouse"
    },{
      name: "Wings",
      img: "assets/img/logo2.png",
      id: "Wings"
    },{
      name: "African: Ethiopian",
      img: "assets/img/logo2.png",
      id: "African: Ethiopian"
    },{
      name: "American",
      img: "assets/img/logo2.png",
      id: "American"
    },{
      name: "Mexican",
      img: "assets/img/logo2.png",
      id: "Mexican"
    },{
      name: "Snacks",
      img: "assets/img/logo2.png",
      id: "Snacks"
    },{
      name: "Healthy",
      img: "assets/img/logo2.png",
      id: "Healthy"
    },{
      name: "Fish and Chips",
      img: "assets/img/logo2.png",
      id: "Fish and Chips"
    },{
      name: "African: Other",
      img: "assets/img/logo2.png",
      id: "African: Other"
    },
  ]


export default datas